export const saveDataStoreUser = (userData) => ({
    type: 'USER_SAVE_DATA',
    userData: userData
})

export const signOutStoreUser = () => ({
    type: 'USER_SIGN_OUT',
})
